"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfChatbotInput = instanceOfChatbotInput;
exports.ChatbotInputFromJSON = ChatbotInputFromJSON;
exports.ChatbotInputFromJSONTyped = ChatbotInputFromJSONTyped;
exports.ChatbotInputToJSON = ChatbotInputToJSON;
/**
 * Check if a given object implements the ChatbotInput interface.
 */
function instanceOfChatbotInput(value) {
    return true;
}
function ChatbotInputFromJSON(json) {
    return ChatbotInputFromJSONTyped(json, false);
}
function ChatbotInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'medical_record_id': json['medical_record_id'] == null ? undefined : json['medical_record_id'],
        'title': json['title'] == null ? undefined : json['title'],
    };
}
function ChatbotInputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'medical_record_id': value['medical_record_id'],
        'title': value['title'],
    };
}
